/**
 * Enum encapsulating various type a user can be-member, guest, unknown
 */ export var UserType = /*#__PURE__*/ function(UserType) {
    UserType["Member"] = "Member";
    UserType["Guest"] = "Guest";
    return UserType;
}({});
/**
 * Enum for "AadUserType" field of Resource
 */ export var AadUserType = /*#__PURE__*/ function(AadUserType) {
    AadUserType["Member"] = "Member";
    AadUserType["Guest"] = "Guest";
    return AadUserType;
}({});
